export default __webpack_public_path__ + "static/media/almendrabold.f74a172a.txt";